export const selectTab = (id: number): void => {
  // すべてのタブとコンテンツを非アクティブにする
  const tabs = document.getElementsByClassName("c-tab__item");
  const tabContents = document.getElementsByClassName("c-tab__content");
  for (var i = 0; i < tabs.length; i++) {
      tabs[i].classList.remove("c-tab__item--active");
  }
  for (var i = 0; i < tabContents.length; i++) {
      tabContents[i].classList.remove("c-tab__content--hide");
      tabContents[i].classList.add("c-tab__content--hide");
  }

  // 選択したタブをアクティブにする
  const tab = document.getElementById("js-tab_index_" + id);
  const tabContent = document.getElementById("js-tab_content_index_" + id);
  tab.classList.add("c-tab__item--active");
  tabContent.classList.remove("c-tab__content--hide");
};